import React from 'react';
import PageLayout from '../components/PageLayout';
import Hero from '../components/Hero';
import { getKeycloakLoginUrl, getDriverAppUrl } from '../auth';
import useBrand from '../branding/useBrand';
import useDocumentTitle from '../hooks/useDocumentTitle';
import './Page.css';
import './ContactPage.css';

function ContactPage() {
  const brand = useBrand();
  const content = brand.pages.contact;
  useDocumentTitle(content.title);

  const mailto = `mailto:${brand.contact.email}?subject=${encodeURIComponent(brand.contact.subject)}`;
  const handleLoginAsCPO = () => { window.location.href = getKeycloakLoginUrl(); };

  return (
    <PageLayout
      hero={(
        <Hero
          title={content.heroTitle}
          lead={content.heroLead}
          actions={(
            <a href={mailto} className="btn btn-primary page-login-btn">
              {content.emailButton}
            </a>
          )}
          hint={(
            <>{content.responseHint}</>
          )}
        />
      )}
    >
      <div className="contact-page">
        <section className="page-section contact-intro">
          <span className="contact-eyebrow">{content.introEyebrow}</span>
          <h2>{content.introTitle}</h2>
          <p>
            {content.introBody}
          </p>
        </section>

        <section className="page-section contact-path-grid" aria-label={content.pathsAriaLabel}>
          {content.paths.map((path) => (
            <article key={path.title} className="contact-path-card">
              <span>{path.label}</span>
              <h3>{path.title}</h3>
              <p>{path.description}</p>
            </article>
          ))}
        </section>

        <div className="contact-main-grid">
          <section className="page-section contact-message-card">
            <span className="contact-eyebrow">{content.messageEyebrow}</span>
            <h2>{content.messageTitle}</h2>
            <ul>
              {content.messageItems.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
            <a href={mailto} className="btn btn-primary contact-email-button">
              {content.emailCta} {brand.contact.email}
            </a>
          </section>

          <aside className="page-section contact-access-card">
            <span className="contact-eyebrow">{content.accessEyebrow}</span>
            <h2>{content.accessTitle}</h2>
            <p>
              {content.accessBody}
            </p>
            <div className="contact-access-actions">
              <button type="button" className="btn btn-primary" onClick={handleLoginAsCPO}>
                {content.loginCta}
              </button>
              <a href={getDriverAppUrl()} className="btn btn-outline-light">
                {content.driverCta}
              </a>
            </div>
          </aside>
        </div>
      </div>
    </PageLayout>
  );
}

export default ContactPage;
